import gql from 'graphql-tag';

export default gql`
  query allNetUoms {
    allNetUoms {
      data {
        code
        id
        nameEn
        nameVn
      }
    }
  }
`;
